exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".multiple-select[data-v-8d0ede26]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-8d0ede26&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/MessageManage/SMSTask/SMSTaskEdit.vue
// module id = 602
// module chunks = 0